import { useTheme } from '@mui/material';
import { tokens, ModeTokens } from '@/theme';

/**
 * Design tokens for whichever mode is active.
 *
 * The `light` argument is an override, not a switch: leave it undefined and the
 * component follows the theme (so it responds to the user's light/dark toggle),
 * or pass it to pin a component to one mode regardless. The pinned case exists
 * because some surfaces are deliberately inverted against their
 * surroundings — the light transfer drawer sitting inside a dark screen.
 */
export const useModeTokens = (light?: boolean): ModeTokens => {
  const theme = useTheme();
  const mode =
    light === undefined ? theme.palette.mode : light ? 'light' : 'dark';
  return tokens(mode);
};

export default useModeTokens;
